import { ProductAction } from '../../core/api/products/entities/product-action.entity';
import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { QuantityUnit } from '../../core/api/quantity-units/entities/quantity-unit.entity';
import { ProductWithBarcode } from '../../core/models/product-with-barcode.model';
import { QuickActionFormControls } from '../form-controls/quick-action.form-controls';
import { QuickActionFormOptions } from '../form-options/quick-action.form-options';
import { BaseForm } from './base.form';

export abstract class QuickActionForm<T extends QuickActionFormControls> extends BaseForm<T> {
  public abstract get amountHint(): string | undefined;
  public abstract get productAction(): ProductAction;
  public abstract get quantityUnit(): QuantityUnit | undefined;
  public abstract canSelectStockItem(stockItem: ProductActiveStockItem): boolean;
  public abstract setAmountToMax(): void;
  protected abstract setChangeListeners(): void;
  protected abstract setInitialValues(): void;

  override options = new QuickActionFormOptions();

  protected _product?: ProductWithBarcode;

  get amount(): number {
    return this.formGroup.controls.amount.value;
  }

  override get controls(): T {
    return this.formGroup.controls as T;
  }

  get quantityUnitName(): string {
    if (this.quantityUnit) {
      return this.amount === 1 ? this.quantityUnit.name : this.quantityUnit.namePlural;
    } else return '';
  }

  get product(): ProductWithBarcode | undefined {
    return this._product;
  }

  set product(product: ProductWithBarcode | undefined) {
    this._product = product;
    this.setInitialValues();
    this.setChangeListeners();
  }

  disable(): void {
    for (const control in this.controls) {
      this.controls[control].disable();
    }
  }

  enable(): void {
    for (const control in this.controls) {
      this.controls[control].enable();
    }
  }
}
